 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account":"account","activity":"activity","apple":"apple","apps":"apps","arena":"arena","avatar":"avatar","badword":"badword","bonus":"bonus","booster":"booster","challenge":"challenge","chat":"chat","progress":"progress","promotion":"promotion","collection":"collection","credit":"credit","duplicate":"duplicate","exoty":"exoty","facebook":"facebook","game":"game","gift":"gift","google":"google","iap":"iap","item":"item","league":"league","mail":"mail","maintenance":"maintenance","news":"news","password":"password","picword":"picword","piggy":"piggy","profile":"profile","quest":"quest","rfm":"rfm","role":"role","scratch":"scratch","send":"send","shop":"shop","slot":"slot","starter":"starter","stripe":"stripe","subscription":"subscription","surprise":"surprise","totem":"totem","tournament":"tournament","translation":"translation","version":"version","locale":"locale","transaction":"transaction"}[chunkId]||chunkId) + "." + {"chunk-87683be2":"cae274c2","chunk-4274cb78":"fe46cb55","account":"a5e1d5ae","activity":"30f9a579","apple":"dd1fbd0a","apps":"3b107e17","arena":"8d420d62","avatar":"8587e644","badword":"4602493f","bonus":"b76ba71b","booster":"2e061db3","challenge":"9c7ddd76","chat":"00982a4e","chunk-726e6d9f":"5220b81c","progress":"b5461807","promotion":"24aa7116","collection":"163751fd","credit":"34ad657c","duplicate":"bc223fec","exoty":"301c4c53","facebook":"f8c3f55d","game":"b4e3aaf6","gift":"eff26ad1","google":"8307d1c8","iap":"4f881bda","item":"ab1ac9d7","league":"b1e3c6c4","mail":"34f1dce6","maintenance":"69362d9c","news":"d03838d3","password":"9b44a1ea","picword":"0e464dfc","piggy":"b67bffd6","profile":"bb6313f7","quest":"59418f22","rfm":"62733486","role":"3a743399","scratch":"1de2dbc6","send":"27cfd512","shop":"65e7a22e","slot":"5e155567","starter":"8c75177c","stripe":"978eaae6","subscription":"cd0ff9cf","surprise":"e7178015","totem":"b1235785","tournament":"896aa151","translation":"d6180b2d","version":"3df7e7bd","locale":"51d5f4aa","transaction":"bf5624cc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-87683be2":1,"account":1,"activity":1,"arena":1,"chunk-726e6d9f":1,"promotion":1,"collection":1,"duplicate":1,"exoty":1,"game":1,"picword":1,"quest":1,"starter":1,"subscription":1,"tournament":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account":"account","activity":"activity","apple":"apple","apps":"apps","arena":"arena","avatar":"avatar","badword":"badword","bonus":"bonus","booster":"booster","challenge":"challenge","chat":"chat","progress":"progress","promotion":"promotion","collection":"collection","credit":"credit","duplicate":"duplicate","exoty":"exoty","facebook":"facebook","game":"game","gift":"gift","google":"google","iap":"iap","item":"item","league":"league","mail":"mail","maintenance":"maintenance","news":"news","password":"password","picword":"picword","piggy":"piggy","profile":"profile","quest":"quest","rfm":"rfm","role":"role","scratch":"scratch","send":"send","shop":"shop","slot":"slot","starter":"starter","stripe":"stripe","subscription":"subscription","surprise":"surprise","totem":"totem","tournament":"tournament","translation":"translation","version":"version","locale":"locale","transaction":"transaction"}[chunkId]||chunkId) + "." + {"chunk-87683be2":"660e527f","chunk-4274cb78":"31d6cfe0","account":"75f7d7af","activity":"381d8b83","apple":"31d6cfe0","apps":"31d6cfe0","arena":"75f7d7af","avatar":"31d6cfe0","badword":"31d6cfe0","bonus":"31d6cfe0","booster":"31d6cfe0","challenge":"31d6cfe0","chat":"31d6cfe0","chunk-726e6d9f":"b1f91f6e","progress":"31d6cfe0","promotion":"d0579461","collection":"75f7d7af","credit":"31d6cfe0","duplicate":"a0d2954e","exoty":"f9ee159c","facebook":"31d6cfe0","game":"381d8b83","gift":"31d6cfe0","google":"31d6cfe0","iap":"31d6cfe0","item":"31d6cfe0","league":"31d6cfe0","mail":"31d6cfe0","maintenance":"31d6cfe0","news":"31d6cfe0","password":"31d6cfe0","picword":"37c59fb3","piggy":"31d6cfe0","profile":"31d6cfe0","quest":"75f7d7af","rfm":"31d6cfe0","role":"31d6cfe0","scratch":"31d6cfe0","send":"31d6cfe0","shop":"31d6cfe0","slot":"31d6cfe0","starter":"b1f91f6e","stripe":"31d6cfe0","subscription":"b1f91f6e","surprise":"31d6cfe0","totem":"31d6cfe0","tournament":"75f7d7af","translation":"31d6cfe0","version":"31d6cfe0","locale":"31d6cfe0","transaction":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
